import type { License } from '@/core/graphql/generated/types';

const formatDate = (
	date: string | number | Date | null | undefined
): string => {
	if (!date) return '';
	return new Date(date).toISOString().split('T')[0];
};

export const mapLicensesIn = (licenses?: License[] | null) => {
	if (!licenses || licenses.length === 0) return [];

	return licenses.map(lic => ({
		vid_V: lic.vid_V,

		// Editable Fields
		licenseNumber_V: lic.licenseNumber_V ?? '',
		typeValue_VId: lic.typeValue_VId ?? '', // Licensing Authority (Editable)
		expirationDate_V: formatDate(lic.expirationDate_V),
		licenseStatus_V: lic.licenseStatus_V,

		// Read-Only Fields
		licenseDegree_V: lic.licenseDegree_V,
		gracePeriod_V: formatDate(lic.gracePeriod_V),
		bestStateLicense_V: lic.bestStateLicense_V,
		licenseCertification_V: lic.licenseCertification_V,
		licenseEligibility_V: lic.licenseEligibility_V,
		licenseStatusCondition_V: lic.licenseStatusCondition_V,
		licenseSubtype_V: lic.licenseSubtype_V,
		comprehensivePrescriptiveAuthority_V:
			lic.comprehensivePrescriptiveAuthority_V,
		comprehensiveSampleEligibility_V: lic.comprehensiveSampleEligibility_V,
		collabAgreeRequired_V: lic.collabAgreeRequired_V,
		ctrlSubstancePrescriptive_V: lic.ctrlSubstancePrescriptive_V,
		ctrlSubstanceSample_V: lic.ctrlSubstanceSample_V,
		deaBusinessActivityCode_V: lic.deaBusinessActivityCode_V,
		deaPaymentIndicator_V: lic.deaPaymentIndicator_V,
		drugSchedule_V: lic.drugSchedule_V,
		sourceAddress_V: lic.sourceAddress_V,
		type_V: lic.type_V, // License Type

		body_V: lic.body_V,
		rxaEligible_V: lic.rxaEligible_V
	}));
};
